import useForgotPassword from './password/useForgotPassword';
import useVerifyCode from './password/useVerifyCode';
import useReset from './password/useReset';
import { useCallback } from 'react';

const usePasswordReset = () => {
    const {
        forgotPassword: triggerForgot,
        isLoading: loadingForgot,
        hasCompleted: forgotCompleted,
        reset: resetForgot,
    } = useForgotPassword();

    const {
        verifyContactCode,
        isLoading: loadingVerify,
        alerts: verifyAlerts,
        hasVerified,
        reset: resetVerify,
    } = useVerifyCode();

    const {
        resetPassword,
        isLoading: loadingReset,
        alerts: resetAlerts,
        reset: resetReset,
    } = useReset();

    const isLoading = loadingForgot || loadingVerify || loadingReset;

    const forgotPassword = useCallback(
        (email: string) => {
            resetVerify();
            resetReset();
            triggerForgot(email);
        },
        [resetVerify, resetReset, triggerForgot]
    );

    const resetAll = useCallback(() => {
        resetForgot();
        resetVerify();
        resetReset();
    }, [resetForgot, resetVerify, resetReset]);

    return {
        forgotPassword,
        verifyContactCode,
        resetPassword,
        isLoading,
        alerts: [...resetAlerts, ...verifyAlerts],
        hasTriggeredForgotPasswordFlow: forgotCompleted,
        hasVerified,
        reset: resetAll,
    };
};
export default usePasswordReset;
